export default __webpack_public_path__ + "static/media/wdct.3f330570.png";